import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {rd, website, websites} from "../../vars/rd";
import PageBack from "../components/buttons/page-back";
import {jsi} from "../../index";

class CSCenter extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    openBrowser(url) {
        jsi.jsi_open_browser(url);
    }

    render() {
        return (
            <div className="customer">
                <h2>
                    <PageBack />
                    고객센터
                </h2>
                <div className="customer-wrap">
                    <h3>서비스 이용에 문의사항이 있으신가요?</h3>
                    <div className="box">
                        <div className="text1">라임덕 고객센터 대표전화</div>
                        <div className="text2">{rd.main.information.customer_tel}</div>
                        <div className="text3">평일 오전 9시 ~ 오후 6시</div>
                    </div>
                    <div className="link-wrap">
                        <div className="list">
                            <div className="item">자주 묻는 질문<img src="/images/icon-link.png" alt="자주 묻는 질문" onClick={()=> this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("faq")}))} /></div>
                            <div className="item">1:1 문의<img src="/images/icon-link.png" alt="1:1 문의" onClick={()=> this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("inquiry")}))}/></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(CSCenter));


// WEBPACK FOOTER //
// ./src/pages/cscenter/index.jsx